import React from "react";
import { formatDate } from "../../../packages/date/dateFunctions.js";

type Props = {
  /**
   * Date in YYYY-MM-DD format.
   */
  date: string;
};

/**
 * Renders amount in cents as normal monetary value.
 */
export const FormattedDate = ({ date }: Props) => {
  return <>{formatDate(date)}</>;
};
